<template>
    <tag
        :display="display"
        :icon="icon"
        :disabled="type === 'archived'"
        class="w-fit h-3/4"
        >
        {{ params.value }}
    </tag>
</template>
<script>
import Tag from "../../ui/Tag.vue";

export default {
    name: "StatusComponent",
    components: {
        Tag,
    },
    data() {
        return {
            type: null,
            icon: null,
            display: null,
        }
    },
    beforeMount() {
        switch (this.params.value) {
            case 'published':
                this.type = 'published';
                this.icon = 'check-circle';
                this.display = 'success';
                break;
            case 'unpublished':
                this.type = 'unpublished';
                this.icon = 'do-not-disturb-on';
                this.display = 'danger';
                break;
            case 'archived':
                this.type = 'archived';
                this.icon = 'archive';
                this.display = 'primary';
                break;
        }
    }
}
</script>
<style scoped>

</style>